<template>
  <div v-if="_client.client_name">
    <reports v-if="_client.client_name !== 'shark'" />
    <shark-reports v-else />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Reports from '@/components/Reports.vue';
import SharkReports from '@/components/SharkReports.vue';

export default {
  components: {
    Reports,
    SharkReports,
  },
  computed: {
    ...mapGetters({
      _client: 'account/getCurrentClient',
    }),
  },
};
</script>
